import { Col, Row } from '@firsttable/web-components/atoms';
import { countFormat, roundToClosest } from '@firsttable/functions';
import { HomeInfo } from '@firsttable/web-components/organisms';

const HowItWorks = ({ siteConfig }) => (
  <Row>
    <Col width={[1, 1 / 3]} mb={['35px', 0]}>
      <HomeInfo
        icon="discovery"
        title="Find a restaurant"
        message={`Find a new restaurant to try from over ${countFormat(
          roundToClosest(siteConfig.restaurantCount, 100)
        )} restaurants globally`}
      />
    </Col>
    <Col width={[1, 1 / 3]} mb={['35px', 0]}>
      <HomeInfo
        icon="reviews"
        title="Select your date and time"
        message="Get in quick to score the ‘first table’ of breakfast, lunch or dinner"
      />
    </Col>
    <Col width={[1, 1 / 3]}>
      <HomeInfo
        icon="discount"
        title="Save 50% on your meal"
        message="Pay a small booking fee and enjoy 50% off the food bill."
      />
    </Col>
  </Row>
);

export default HowItWorks;
